import { navigationAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export function useTopSales() {
  return useHttpFetch(navigationAPI.getTopsales)
}
